<!-- Table export case -->
@if (!isLoading) {
  <!-- Single export button -->
  @if (formats.length === 1) {
    <button (click)="export(formats[0])" class="btn icon-download print {{isBasicViewType ? 'basic' : 'primary'}}">
      @if (customButtonLabel) {
        <div class="col-12 col-sm">
          {{customButtonLabel}}
        </div>
      }
      @if (!customButtonLabel) {
        <div class="col-12 col-sm">
          {{isBasicViewType ? fileFormats[formats[0]] : 'Export as ' + fileFormats[formats[0]]}}
        </div>
      }
    </button>
  } @else {
    <button [matMenuTriggerFor]="menu"
      class="btn icon-download align-v-center align-h-space-between pr-5 {{isBasicViewType ? 'basic' : 'gradient'}}">
      Export
      <i class="icon-caret-down ic-primary ml-10"></i>
    </button>
    <mat-menu #menu="matMenu">
      @for (format of formats; track format) {
        <button
          class="btn"
          mat-menu-item
          (click)="export(format)">
          {{isBasicViewType ? format : "Export as " + format}}
        </button>
      }
    </mat-menu>
  }
  <!-- Multiple export mat-menu -->
}

<!-- HTML export case -->
@if (isLoading) {
  <button [disabled]="isLoading" (click)="export()" [ngClass]="buttonClass" class="btn icon-download print">
    {{ isLoading ? 'Downloading...' : 'Export as PDF' }}
  </button>
}
